<template>
  <div :class="{errors:downPaymentGreaterThanPrinciple}">
    <InputField
      class="cost input"
      label="Price of Home"
      :value="showValue(FORMATED_PRINCIPLE, 'PRINCIPLE', '')"
      target="PRINCIPLE"
      :prefix="dollar"
      :update="updatePrinciple"
      tooltip="test"
    />
    <InputField
      class="downpayment-dollars input"
      label="Down payment"
      :value="showValue(FORMATED_DOWNPAYMENT,'DOWNPAYMENT', '')"
      target="DOWNPAYMENT"
      :prefix="dollar"
      :update="update"
    />
    <InputField
      target="DOWNPAYMENT_PERCENTAGE"
      label=" "
      class="downpayment-percentage input"
      :value="showValue(DOWNPAYMENT_PERCENTAGE,'DOWNPAYMENT_PERCENTAGE', '')"
      :suffix="percentage"
      :update="update"
      tooltip="test"
    />
    <InputField
      class="term input"
      label="Length of loan"
      target="TERM"
      tooltip="test"
      :value="showValue(TERM_YEARS,'TERM', '')"
      :suffix="years"
      :update="update"
    />
    <InputField
      label="Interest  Rate"
      class="downpayment-interest input"
      :value="showValue(INTEREST_PERCENTAGE,'INTEREST_RATE', '')"
      target="INTEREST_RATE"
      :update="update"
      :suffix="percentage"
      tooltip="test"
    />
  </div>
</template>

<script>
import InputField from "./util/InputField";
import { checkValidation } from "../util/validate";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import { STATE, MUTATIONS, GETTERS, ACTIONS } from "../storeConstants";
import { roundCurrency, roundDollarsToCents } from "../util/bankersRound";
import house from "../../public/house.svg";
import dollar from "../../public/dollar-sign.svg";
import percentage from "../../public/percentage.svg";
import years from "../../public/years.svg";

const {
  DOWNPAYMENT_PERCENTAGE,
  MODIFIED_TERM,
  FORMATED_PRINCIPLE,
  FORMATED_DOWNPAYMENT,
  INTEREST_PERCENTAGE,
  TERM_YEARS
} = GETTERS;
const { CHANGE } = MUTATIONS;
const {
  UPDATE_TERM,
  UPDATE_PRINCIPLE,
  UPDATE_INTEREST_RATE,
  UPDATE_DOWNPAYMENT
} = ACTIONS;

export default {
  data: () => {
    return {
      dollar: dollar,
      years: years,
      percentage: percentage,
      house: house,
      max: 100000000,
      min: 100000,
      interval: 100
    };
  },
  computed: {
    ...mapState({
      state: state => state.base
    }),
    downPaymentGreaterThanPrinciple() {
      if (this.state.DOWNPAYMENT < this.state.PRINCIPLE) return false;
      if (this.DOWNPAYMENT_PERCENTAGE > 99.99) return false;
      this.CHANGE({
        target: STATE.ERRORS,
        value: {
          ...this.state.errors,
          [STATE.PRINCIPLE]: ["Principle must be greater than downpayment"]
        }
      });
      return false;
    },
    ...mapGetters([
      DOWNPAYMENT_PERCENTAGE,
      MODIFIED_TERM,
      FORMATED_DOWNPAYMENT,
      FORMATED_PRINCIPLE,
      INTEREST_PERCENTAGE,
      TERM_YEARS
    ])
  },
  methods: {
    roundDollarsToCents: roundDollarsToCents,
    ...mapMutations([CHANGE]),
    ...mapActions([
      UPDATE_TERM,
      UPDATE_PRINCIPLE,
      UPDATE_DOWNPAYMENT,
      UPDATE_INTEREST_RATE
    ]),
    showValue(value, target, errorState) {
      return typeof this.state.ERRORS[target] === "undefined"
        ? value
        : errorState;
    },

    update(e) {
      let target = e.target.parentNode.id;
      let value = e.target.value;
      const valid = checkValidation({
        state: this.state,
        change: this.CHANGE,
        target,
        value
      });
      switch (target) {
        case "TERM":
          if (valid) {
            value = parseInt(value, 10) * 12;
            this.UPDATE_TERM({ target, value });
          }
          break;

        case "DOWNPAYMENT":
          value = value.replace(/[^0-9.]/g, "");
          value = this.roundDollarsToCents(value);
          if (value < this.state.PRINCIPLE) {
            this.UPDATE_DOWNPAYMENT({ target, value });
          }
          break;
        case "INTEREST_RATE":
          value = value / 100;
          this.UPDATE_INTEREST_RATE({ target, value });
          break;
        case "DOWNPAYMENT_PERCENTAGE":
          value = value.replace(/[^0-9.]/g, "");

          target = "DOWNPAYMENT";
          value = Math.round(this.state.PRINCIPLE * (value / 100));
          this.UPDATE_DOWNPAYMENT({ target, value });
        default:
          this.CHANGE({ target, value });
          break;
      }
    },
    updatePrinciple(value) {
      checkValidation({
        state: this.state,
        change: this.CHANGE,
        target: "PRINCIPLE",
        value
      });
      const newPrinciple =
        typeof value === "object"
          ? roundDollarsToCents(
              parseInt(value.target.value.replace(/[^0-9.-]/g, ""), 10)
            )
          : value;
      if (!isNaN(newPrinciple)) {
        this.UPDATE_PRINCIPLE({ target: "PRINCIPLE", value: newPrinciple });
      }
    }
  },
  components: {
    InputField
  }
};
</script>

<style scoped lang="scss">
@mixin gradient-text($start-color, $end-color, $fallback: #000) {
  color: $fallback;
  @supports (background-clip: text) {
    color: transparent;
    background-image: linear-gradient(to right, $start-color, $end-color),
      linear-gradient(to bottom, #fff, #fff);
    -webkit-background-clip: text;
    background-clip: text;
  }
}
.downpayment {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
  @media (min-width: 768px) {
    justify-content: flex-start;
  }
  .image {
    margin-bottom: 45px;
  }
  .principle {
    // @include gradient-text(#60c5b7, #acd14c);
    font-size: 38px;
    text-align: center;
    width: 100%;
    color: #60c5b7;
    font-family: "Poppins", sans-serif;
  }
  .sub-title {
    font-family: "Poppins", sans-serif;
    color: #808080;
    text-align: center;
    width: 100%;
    margin-bottom: 14px;
  }

  .input-field {
    left: -2px;
    position: relative;
    margin-bottom: 20px;
    width: 100%;
    @media (min-width: 768px) {
      margin-bottom: 12.5px;
    }
    &.downpayment-dollars {
      margin-right: 0;
      width: calc(76.3%);
      input {
        border-right: 0px !important;
      }
    }
    &.downpayment-percentage {
      margin-left: 0;
      width: calc(23.7%);
    }
  }
}
</style>
<style lang="scss">
.input-field {
  &.downpayment {
    input {
      border-right: 0px;
    }
    .icon {
      display: none;
    }
  }
  &.downpayment-percentage {
    top: 1px;
    position: relative;
    input {
      background-size: 12px;
    }
  }
  &.downpayment-interest {
    input {
      background-size: 12px;
    }
  }
  &.term {
    input {
      background-size: 36px;
    }
  }
}
</style>